<template>
	<div>
		<!-- 1ère barre -->
		<AmeliBanner />

		<HeaderBar
			:navigation-items="navigationItems"
			:mini-version="isMobile"
		>
			<template #brand-content>
				<span
					v-if="!isMobile"
					class="text-subtitle-1 text-sm-h3"
					style="color: #2B6138"
				>
					Mon&nbsp;soutien&nbsp;psy
				</span>
			</template>
			<template
				#navigation-bar-secondary-content
			>
				<div
					v-for="(url, index) in urlList"
					:key="url.label"
					class="d-flex flex-grow-1 justify-end"
				>
					<v-btn
						:href="url.url"
						class="font-weight-bold white--text"
						target="_blank"
						text
					>
						{{ url.label }}
					</v-btn>
					<v-divider
						v-if="index < urlList.length - 1"
						class="white my-2"
						dark
						vertical
					/>
				</div>
			</template>
			<template
				#navigation-drawer-append
			>
				<div class="d-flex flex-column flex-grow-1 justify-end align-start">
					<v-btn
						v-for="url in urlList"
						:key="url.label"
						:href="url.url"
						class="font-weight-bold white--text"
						text
					>
						{{ url.label }}
					</v-btn>
				</div>
			</template>
		</HeaderBar>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { NavigationItem } from '@cnamts/vue-dot/src/patterns/HeaderBar/types';
	import { RouteName } from '@/router/route-name';
	import AmeliBanner from '@/components/layout/AppHeader/AmeliBanner.vue';
	import { StringUtil } from '@/utils/string-util';

	// Définition de l'objet représentant une URL
	type UrlItem = { readonly label: string; readonly url: string };

	/**
	 * Bandeau de navigation de la CNAM
	 */
	@Component({
		components: { AmeliBanner }
	})
	export default class AppHeader extends Vue {

		/**
		 * Retourne la liste des URL à afficher dans le menu de navigation
		 *
		 * @returns Liste des URL
		 */
		get urlList(): UrlItem[] {
			const urlConfig: { label: string; url: string | null | undefined }[] = [
				{ label: 'Psychologues', url: window.URL_SUPPORT_SYSTEM_REFUND },
				{ label: 'Médecins', url: window.URL_SUPPORT_SYSTEM_PSY_CONV },
				{ label: 'Sages-femmes', url: window.URL_SUPPORT_SYSTEM_SAGE_FEMME }
			];

			return urlConfig.filter(item => !StringUtil.isNullOrEmpty(item.url)) as UrlItem[];
		}

		get navigationItems(): NavigationItem[] | undefined {
			if (this.$maintenanceEnabled) {
				return undefined;
			}

			return [
				{
					label: 'Annuaire',
					to: {
						name: RouteName.HOME
					}
				},
				{
					label: 'Contact',
					to: {
						name: RouteName.CONTACT
					}
				}
			];
		}

		/**
		 * Détermine si l'application est en vue mobile
		 */
		get isMobile(): boolean {
			return this.$vuetify.breakpoint.xsOnly;
		}
	}
</script>
